import { createFileRoute } from "@tanstack/react-router";
import { TenantAuditLogDetailPage } from "@client/components/admin/audit-logs/audit-log-detail-page";

export const Route = createFileRoute("/_app/tenant-settings/audit-logs/$id")({
  component: TenantAuditLogDetailRoute,
});

function TenantAuditLogDetailRoute() {
  const { id } = Route.useParams();
  return <TenantAuditLogDetailPage id={id} />;
}
